/**
 * @file ImpersonationBanner.js
 * @description Banner flotante que aparece en la parte superior de la pantalla cuando
 * un super admin está en modo de impersonación. Proporciona un recordatorio visual
 * constante y un botón para salir del modo de impersonación.
 */
import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { BsShieldLock, BsArrowLeft } from 'react-icons/bs';
import AuthContext from '../context/AuthContext';

const ImpersonationBanner = () => {
    const { isImpersonating, stopImpersonating, business } = useContext(AuthContext);

    // No renderizar nada si no está en modo de impersonación
    if (!isImpersonating) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#dc3545', // Rojo Bootstrap danger
                color: 'white',
                padding: '0.5rem 1rem',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                animation: 'pulse-subtle 2s ease-in-out infinite',
                minHeight: '48px'
            }}
            className="impersonation-banner"
        >
            {/* Icono y texto informativo */}
            <div className="d-flex align-items-center gap-2">
                <BsShieldLock size={20} />
                <span className="fw-bold d-none d-md-inline">
                    MODO IMPERSONACIÓN
                </span>
                <span className="d-none d-lg-inline">
                    {business?.name ? `| Viendo como: ${business.name}` : ''}
                </span>
                <span className="fw-bold d-md-none">
                    IMPERSONACIÓN
                </span>
            </div>

            {/* Botón para salir de impersonación */}
            <Button
                variant="light"
                size="sm"
                onClick={stopImpersonating}
                className="fw-bold d-flex align-items-center gap-2"
                style={{
                    whiteSpace: 'nowrap',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <BsArrowLeft />
                <span className="d-none d-sm-inline">Salir de Impersonación</span>
                <span className="d-sm-none">Salir</span>
            </Button>

            {/* Estilos inline para la animación */}
            <style>{`
                @keyframes pulse-subtle {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.95;
                    }
                }
                
                .impersonation-banner {
                    font-size: 0.9rem;
                }
                
                @media (max-width: 576px) {
                    .impersonation-banner {
                        font-size: 0.85rem;
                        padding: 0.4rem 0.75rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default ImpersonationBanner;
